import { NextPage } from 'next';
import Head from 'next/head';
import React from 'react';
import { useIntl } from 'react-intl';

import ogThumbnail from '@/assets/escapes/og-thumbnail.gif';
import { ExploreTopDestinations } from '@/components/escapes/ExploreTopDestinations';
import { FAQs } from '@/components/escapes/FAQs';
import { Hero } from '@/components/escapes/Hero';
import { HowItWorks } from '@/components/escapes/HowItWorks';
import { MapSection } from '@/components/escapes/MapSection';
import { ProgressCircle } from '@/components/escapes/ProgressCircle';
import { SectionWrapper } from '@/components/escapes/Section';
import { WhyPeopleLoveOutdoorsy } from '@/components/escapes/WhyPeopleLoveOutdoorsy';
import HeadMeta from '@/components/static-pages/HeadMeta';

const Escapes: NextPage = () => {
  const intl = useIntl();

  return (
    <>
      <HeadMeta
        title={intl.formatMessage({
          defaultMessage: 'All-in-one bookings for resorts and delivered RVs | Outdoorsy Escapes',
          id: '+kc7ZN',
        })}
        description={intl.formatMessage({
          defaultMessage:
            'Adventure made easy. Book your Outdoorsy Escape and find your premium RV delivered, set up, and ready for unforgettable moments—just show up and start relaxing.',
          id: '0gRRQp',
        })}
        thumbnailURL={ogThumbnail.src}
        hideOutdoorsyTitle
      />
      <Head>
        <style>{`
          body {
            --page-content-bg-color: #EEECE3;
            --page-header-bg-color: #EEECE3;
            --page-footer-bg-color: #EEECE3;
          }
        `}</style>
      </Head>

      <div className="root">
        <Hero />
        <ProgressCircle />

        <SectionWrapper className="py-10 lg:pt-20">
          <HowItWorks />
        </SectionWrapper>

        <SectionWrapper className="py-10">
          <ExploreTopDestinations />
        </SectionWrapper>

        <SectionWrapper className="py-10 lg:pb-20">
          <WhyPeopleLoveOutdoorsy />
        </SectionWrapper>

        <SectionWrapper className="hidden py-10">
          <MapSection />
        </SectionWrapper>

        <SectionWrapper className="py-10 md:py-16 bg-[#FBF8EF]">
          <FAQs />
        </SectionWrapper>
      </div>
    </>
  );
};

Escapes.getInitialProps = async () => {
  return {
    isEscapesPage: true,
  };
};

export default Escapes;
